module.exports = __webpack_public_path__ + "static/example-playlist-b1753754b8d612db5a01fa9771b7bb50.png";